const updates = [
  { date: '07-30', title: '《暗夜追踪》第12集更新上线', tag: '热门', tagColor: 'bg-primary-100 text-primary-700' },
  { date: '07-30', title: '《星际迷航：新纪元》全集上线', tag: '新剧', tagColor: 'bg-accent-100 text-accent-700' },
  { date: '07-29', title: '《长安秘史》第28集高清修复版发布', tag: '修复', tagColor: 'bg-secondary-100 text-secondary-700' },
  { date: '07-29', title: '《深海冒险》最新季第5集同步更新', tag: '同步', tagColor: 'bg-primary-100 text-primary-700' },
  { date: '07-28', title: '《春风十里不如你》全40集整理上线', tag: '合集', tagColor: 'bg-accent-100 text-accent-700' },
  { date: '07-28', title: '《极限挑战》最新一期已更新', tag: '综艺', tagColor: 'bg-secondary-100 text-secondary-700' },
  { date: '07-27', title: '《古墓迷踪》电影版高清首发', tag: '首发', tagColor: 'bg-primary-100 text-primary-700' },
  { date: '07-27', title: '《异世界勇者》第18集字幕精校版', tag: '精校', tagColor: 'bg-accent-100 text-accent-700' },
];

export default function UpdatesSection() {
  return (
    <section
      id="updates"
      className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100 scroll-mt-16"
    >
      <div className="max-w-4xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center">
          更新速递
        </h2>
        <div className="mt-2 w-12 h-1 bg-primary-500 mx-auto rounded-full"></div>

        <div className="mt-10 relative">
          <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-background-300 -translate-x-1/2 hidden md:block"></div>

          <div className="flex flex-col gap-6">
            {updates.map((item, i) => (
              <div
                key={i}
                className={`relative flex flex-col md:flex-row gap-4 items-start ${
                  i % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                }`}
              >
                <div className={`flex-1 ${i % 2 === 0 ? 'md:text-right md:pr-12' : 'md:text-left md:pl-12'}`}>
                  <div className={`inline-flex items-center gap-2 ${i % 2 === 0 ? 'md:flex-row-reverse' : ''}`}>
                    <span className="text-xs font-mono text-foreground-500 whitespace-nowrap">{item.date}</span>
                    <span className={`px-2 py-0.5 text-xs font-medium rounded-full whitespace-nowrap ${item.tagColor}`}>
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="mt-1 text-sm font-medium text-foreground-800 hover:text-primary-500 transition-colors cursor-pointer">
                    {item.title}
                  </h3>
                </div>

                <div className="hidden md:flex absolute left-1/2 -translate-x-1/2 w-3 h-3 rounded-full bg-primary-500 ring-4 ring-background-100 z-10"></div>

                <div className="flex-1 hidden md:block"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}